import { render, staticRenderFns } from "./PaymentDepositType.vue?vue&type=template&id=73d1629a"
import script from "./PaymentDepositType.vue?vue&type=script&lang=js"
export * from "./PaymentDepositType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports